module.exports = __webpack_public_path__ + "img/look13.f6b6ef30.png";